//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            lineList:[]
        }
    },
    props:{
        uuid:{
            type:String,
            default:''
        },
        type:{
            type:Number,
            default:null
        },
        nodeInfos:{
            type:Array,
            default: ()=>[]
        },
        tmpl:{
            type:String,
            default:'rb_y_dyx',
        }
    },
    methods:{
        // 查看更多
        moreClick(){
            this.STATISTICS_CONFIG.insur_insurestatus_more_click();
            this.lineList=this.nodeInfos;
        },
        // 查看保单
        checkDetail(){
            this.STATISTICS_CONFIG.insur_insurestatus_policy_click();
            this.$router.push({
                path: "/orderDetail",
                query:{
                    uuid:this.uuid,
                    insureType:this.type,
                    templateFlag:this.tmpl,
                    flag:'postdisable'
                }
            });
        }
    },
    created(){
        this.lineList=this.nodeInfos.slice(0,3);
    }
}
